import colors from 'style-utils/colors';
import { withPadding, WithPaddingProps } from 'style-utils/dimensionsMixins';
import media from 'style-utils/media-queries';
import { Container } from 'styled-bootstrap-grid';
import styled, { StyledProps } from 'styled-components';

export const Page = styled(Container)`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  background: ${colors.transparent};
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 10rem;
  /* We want to stretch it as much as possible if is inside a flex container. */
  flex: 1 0 auto;

  & > * {
    flex: 0 0 auto;
  }

  position: relative;
  height: auto;

  ${media.desktop`
    width: calc(100vw - 256px);
  `}
  ${media.breakpoint.lg`
    padding-bottom: unset;
  `}
`;

if (!import.meta.env.PROD) {
  Page.displayName = 'Page';
  Page.defaultProps = {
    'aria-label': 'Page',
  };
}
type PageContent = StyledProps<{ channel?: number } & WithPaddingProps>;
export const PageContent = styled.div<PageContent>`
  ${withPadding};
  flex: 1 0 auto;
  width: 100%;
  margin: 0 auto;
  ${({ channel, theme: { floatingButton } }) =>
    channel !== 62 && `padding-bottom: ${floatingButton.height};`};
`;

if (!import.meta.env.PROD) {
  PageContent.displayName = 'PageContent';

  PageContent.defaultProps = {
    'aria-label': 'PageContent',
  };
}
